/**
 * Коды ошибок модуля заметок: пределы размера, неизвестная заметка, неизвестный клиенту
 * формат, нет ключа пользователя на устройстве, шифротекст не расшифровывается
 */
export enum EnumNoteError {
  IMAGE_TOO_LARGE = 'image_too_large',
  NOTE_TOO_LARGE = 'note_too_large',
  NOTE_NOT_FOUND = 'note_not_found',
  FORMAT_NOT_SUPPORTED = 'format_not_supported',
  NO_USER_KEY = 'no_user_key',
  CANNOT_DECRYPT = 'cannot_decrypt',
}
